var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1871_14994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.18 9.12062C20.18 11.5949 18.1742 13.6006 15.7 13.6006C13.2257 13.6006 11.22 11.5949 11.22 9.12062C11.22 6.64639 13.2257 4.64062 15.7 4.64062C18.1742 4.64062 20.18 6.64639 20.18 9.12062Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.34 27.5995H4.5V25.9995C4.5 21.636 7.38704 17.9524 11.34 16.7852",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.26,
    y: 17.4004,
    width: 14,
    height: 10,
    rx: 1,
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.76 17.9004C18.76 19.5572 17.4169 20.9004 15.76 20.9004",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.76 17.9004C25.76 19.5572 27.1032 20.9004 28.76 20.9004",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.76 26.9004C18.76 25.2435 17.4169 23.9004 15.76 23.9004",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.76 26.9004C25.76 25.2435 27.1032 23.9004 28.76 23.9004",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1871_14994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(2.75 2.40039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.fcccf0c4cc0cf137640ebfb990232c12.svg";
export { ForwardRef as ReactComponent };